export const galleryItems = [
  {
    id: 1,
    title: 'Busan Port Container Terminal',
    location: 'Busan, South Korea',
    category: 'korea',
    height: 'tall',
    url: 'https://public.readdy.ai/ai/img_res/48495aea7c832f05bc502a20c9b727fd.jpg',
  },
  {
    id: 2,
    title: 'Saigon River Trade Route',
    location: 'Ho Chi Minh City, Vietnam',
    category: 'vietnam',
    height: 'normal',
    url: 'https://readdy.ai/api/search-image?query=Saigon%20River%20Ho%20Chi%20Minh%20City%20Vietnam%20aerial%20view%20cargo%20boats%20trade%20logistics%20city%20skyline%20Bitexco%20tower%20sunset%20dramatic%20lighting%20modern%20urban%20river&width=600&height=500&seq=g2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Korea-Vietnam Business Forum 2024',
    location: 'Seoul, South Korea',
    category: 'events',
    height: 'normal',
    url: 'https://readdy.ai/api/search-image?query=professional%20business%20conference%20forum%20Korea%20Vietnam%20executives%20shaking%20hands%20modern%20convention%20center%20stage%20presentation%20banners%20navy%20blue%20corporate%20atmosphere%20formal%20business%20event&width=600&height=500&seq=g3&orientation=landscape',
  },
  {
    id: 4,
    title: 'Incheon International Cargo Hub',
    location: 'Incheon, South Korea',
    category: 'korea',
    height: 'normal',
    url: 'https://readdy.ai/api/search-image?query=Incheon%20airport%20cargo%20terminal%20logistics%20aircraft%20freight%20night%20lights%20aerial%20photography%20modern%20infrastructure%20South%20Korea%20professional%20aviation%20logistics%20hub%20deep%20navy%20twilight&width=600&height=500&seq=g4&orientation=landscape',
  },
  {
    id: 5,
    title: 'Hai Phong Deep Water Port',
    location: 'Hai Phong, Vietnam',
    category: 'vietnam',
    height: 'tall',
    url: 'https://readdy.ai/api/search-image?query=Hai%20Phong%20deep%20water%20port%20Vietnam%20massive%20container%20terminal%20cargo%20vessels%20gantry%20cranes%20industrial%20port%20infrastructure%20aerial%20view%20dramatic%20cinematic%20lighting%20metallic%20silver%20tones%20deep%20blue%20ocean&width=600&height=800&seq=g5&orientation=portrait',
  },
  {
    id: 6,
    title: 'Joint Trade Delegation Seoul',
    location: 'Gangnam, Seoul',
    category: 'events',
    height: 'normal',
    url: 'https://readdy.ai/api/search-image?query=business%20delegation%20meeting%20modern%20glass%20boardroom%20Seoul%20Gangnam%20panoramic%20city%20view%20Korean%20Vietnamese%20executives%20formal%20corporate%20atmosphere%20navy%20silver%20interior%20design%20professional&width=600&height=500&seq=g6&orientation=landscape',
  },
  {
    id: 7,
    title: 'Electronics Export Hub',
    location: 'Hanoi, Vietnam',
    category: 'vietnam',
    height: 'normal',
    url: 'https://readdy.ai/api/search-image?query=modern%20electronics%20manufacturing%20facility%20Vietnam%20high%20tech%20clean%20room%20workers%20assembling%20circuit%20boards%20corporate%20production%20floor%20professional%20industrial%20clean%20minimalist%20background&width=600&height=500&seq=g7&orientation=landscape',
  },
  {
    id: 8,
    title: 'KVTA Annual Awards Ceremony',
    location: 'Lotte Hotel, Seoul',
    category: 'events',
    height: 'tall',
    url: 'https://readdy.ai/api/search-image?query=elegant%20corporate%20awards%20ceremony%20gala%20dinner%20luxury%20hotel%20Seoul%20Korea%20Vietnam%20flags%20on%20stage%20executives%20receiving%20awards%20crystal%20chandeliers%20navy%20blue%20silver%20decor%20professional%20photography&width=600&height=800&seq=g8&orientation=portrait',
  },
  {
    id: 9,
    title: 'Steel Manufacturing Partnership',
    location: 'Pohang, South Korea',
    category: 'korea',
    height: 'normal',
    url: 'https://readdy.ai/api/search-image?query=POSCO%20steel%20plant%20Pohang%20South%20Korea%20aerial%20view%20industrial%20factory%20complex%20manufacturing%20infrastructure%20dramatic%20sky%20metallic%20tones%20professional%20corporate%20photography%20clean%20composition&width=600&height=500&seq=g9&orientation=landscape',
  },
];

export type GalleryCategory = 'all' | 'korea' | 'vietnam' | 'events';
